exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".serce-box[data-v-49e9229a]{height:32px;width:32px;border-radius:50%}@media (max-width: 767px){.serce-box[data-v-49e9229a]{height:38px;width:38px}}\n", ""]);

// exports
